import CCLoader from './CCLoader';

export default CCLoader;
